import { AccessBlueberryAccountDialog } from "#/components/telemedicine/pediatrics/AccessBlueberryAccountDialog"
import useGetUserInfoConditionsSubset from "#/services/user/hooks/useGetCurrentUserConditionsSubset"
import { useTelemedicineForPediatricsActivationStatus } from "#/components/telemedicine/pediatrics/hooks/useTelemedicineForPediatricsActivation"
import { useButtonClickTracking } from "#/services/analytics/useButtonClickTracking"
import { Box, Button, InternalIcon, Link } from "@carrotfertility/carotene-core"
import React, { useState } from "react"

function TelemedicineButton({
  isDisabled,
  onClick,
  children
}: {
  isDisabled: boolean
  onClick: () => void
  children: React.ReactNode
}): JSX.Element {
  return (
    <Box
      sx={(theme) => ({
        marginBlockStart: theme.spacing(theme.tokens.spacing.xs),
        marginBlockEnd: theme.spacing(theme.tokens.spacing.lg),
        ":last-child": { marginBlockEnd: 0 }
      })}
    >
      <Button onClick={onClick} disabled={isDisabled}>
        {children}
      </Button>
    </Box>
  )
}

function TelemedicineLink({
  isDisabled,
  onClick,
  children
}: {
  isDisabled: boolean
  onClick: () => void
  children: React.ReactNode
}): JSX.Element {
  if (isDisabled) {
    return null
  }
  return (
    <Box>
      <Link component={"button"} endIcon={<InternalIcon fontSize="small" color="primary" />} onClick={onClick}>
        {children}
      </Link>
    </Box>
  )
}

function TelemedicineForPediatricsLinkInternal({
  variant,
  children
}: {
  variant: "button" | "link"
  children: React.ReactNode
}): JSX.Element {
  const [openDialogFlow, setOpenDialogFlow] = useState(false)
  const { data } = useGetUserInfoConditionsSubset()
  const { ctaButtonText } = useTelemedicineForPediatricsActivationStatus()
  const { trackButtonClick } = useButtonClickTracking()
  const isDisabled = data?.hasCarrotPlanOnTheWay ?? false

  const handleClick = () => {
    trackButtonClick({
      name: ctaButtonText
    })
    setOpenDialogFlow(true)
  }

  return (
    <>
      {variant === "button" ? (
        <TelemedicineButton isDisabled={isDisabled} onClick={handleClick}>
          {children}
        </TelemedicineButton>
      ) : (
        <TelemedicineLink isDisabled={isDisabled} onClick={handleClick}>
          {children}
        </TelemedicineLink>
      )}
      <AccessBlueberryAccountDialog open={openDialogFlow} onClose={() => setOpenDialogFlow(false)} />
    </>
  )
}

export function TelemedicineForPediatricsLink({ children }: { children: React.ReactNode }): JSX.Element {
  return <TelemedicineForPediatricsLinkInternal variant="link">{children}</TelemedicineForPediatricsLinkInternal>
}

export function TelemedicineForPediatricsButton({ children }: { children: React.ReactNode }): JSX.Element {
  return <TelemedicineForPediatricsLinkInternal variant="button">{children}</TelemedicineForPediatricsLinkInternal>
}
